import { render } from "./PrivacyView.vue?vue&type=template&id=c87170be&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=c87170be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87170be"]])

export default __exports__